export const Colors = {
  secondary: "#820000",
  primary: "#7dbfdd",
  lightGrey: "#bebebe",
  white: "#fff",
  grey: "#6a6a6a",
  black: "#1d1d1d",
  inputGrey: "#EBEBEB",
};
